import ApplicationInsights from '../providers/ApplicationInsights';
export default function useInsights() {
    return {
        trackEvent: function (eventName, properties) {
            ApplicationInsights.applicationInsights.trackEvent({
                name: eventName,
                properties: properties
            });
            ApplicationInsights.applicationInsights.flush();
        }
    };
}
//# sourceMappingURL=UseInsights.js.map